import React, { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { FaSignInAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoSGR from '../../assets/logo.svg';
import logoSwint from '../../assets/swintLogo.svg';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Loading from '../../components/Loading';
import { useAuth } from '../../contexts/authContext';
import { errorToast } from '../../utils/toast';
import { Container, Content } from './styles';

interface LoginProps {
  user: string;
  password: string;
  captcha: string | null | undefined;
}

const Login: React.FC = () => {
  const { register, handleSubmit } = useForm();
  const { signIn } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const reRef = useRef<ReCAPTCHA>() as any;
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async (data: LoginProps) => {
      setLoading(true);
      const captcha = await reRef.current?.execute(
        process.env.REACT_APP_RECAPTCHA_KEY_SITE,
        {
          action: 'login',
        },
      );
      reRef.current?.reset();

      if (!captcha) {
        errorToast({ message: 'Captcha é necessário!' });
        return;
      }

      const loginData = {
        user: data.user,
        password: data.password,
        captcha,
        action: 'login',
      };
      const response = await signIn(loginData);

      if (response.error) errorToast({ message: response.message });
      setLoading(false);
    },
    [signIn],
  );

  return (
    <>
      <Container>
        <img src={logoSGR} alt="Logo SGRLoc" />
        <Content>
          <img src={logoSwint} alt="Logo Swint" />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              {...register('user')}
              type="text"
              placeholder="Informe seu usuario"
              label="USUÁRIO"
            />
            <Input
              {...register('password')}
              type="password"
              placeholder="Informe sua senha"
              label="SENHA"
            />
            <div>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY_SITE || 'secret'}
                size="invisible"
                ref={reRef}
              />
            </div>
            <Button type="submit" title="ENTRAR" icon={FaSignInAlt} />
          </form>
          <Link to="/forgotPassword">Esqueci a senha</Link>
        </Content>
        {loading && <Loading />}
      </Container>
    </>
  );
};

export default Login;
